import type { ConfirmationModalProps } from "../confirmation-modal/confirmation-modal";

export type ModalCloseSource = "user" | "code";

export interface ModalCloseOutcome {
  shouldKeepModalOpen: boolean;
}

export interface ModalBehaviorOptions {
  hasCloseButton?: boolean;
  closeOnBgClick?: boolean;
  requireCloseConfirmation?: boolean;
  closeConfirmationProps?: Omit<ConfirmationModalProps, "onSubmit">;
  onClose?: () => ModalCloseOutcome | void;
}

export const keepModalOpen: ModalCloseOutcome = { shouldKeepModalOpen: true };
